import { useEffect } from 'react';
import { Check } from 'lucide-react';
import styles from './Toast.module.css';

/**
 * @param {string}  message
 * @param {Function} onDismiss  — 안정적인 참조를 넘겨야 타이머가 매 렌더 초기화되지 않는다 (useCallback 권장)
 */
export default function Toast({ message, onDismiss, duration = 2000 }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, duration);
    return () => clearTimeout(t);
  }, [onDismiss, duration]);

  return (
    <div className={styles.toast}>
      <Check className={styles.check} size={16} strokeWidth={3} />
      <span className={styles.message}>{message}</span>
    </div>
  );
}
